import { render } from "./RewardsView.vue?vue&type=template&id=553463cf&scoped=true"
import script from "./RewardsView.vue?vue&type=script&lang=js"
export * from "./RewardsView.vue?vue&type=script&lang=js"

import "./RewardsView.vue?vue&type=style&index=0&id=553463cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553463cf"]])

export default __exports__